// 进行模块的 单独路由
// 导入模块
import solution from '../components/solution';


// 配置路由
export default{
    path:"/solution",
    component:solution,

}



// WEBPACK FOOTER //
// ./src/router/solution.js